import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { IMAGE, BANNER, SUBCATEGORYTYPE, CATEGORY, SUBCATEGORY } from 'src/app/config';

@Component({
    selector: 'app-subsubcategory',
    templateUrl: './subsubcategory.component.html',
    styleUrls: ['./subsubcategory.component.css'],
    
})
export class SubsubcategoryComponent implements OnInit {
  subid:any;
  data:any;
  baseUrl:any;
  loader:boolean;
  page:boolean;
  slideConfig = {
    "slidesToShow": 4,
    "slidesToScroll": 1,
    "dots": false,
    "infinite": true,
    "autoplay": true,
    "arrows": false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  };
  // baseUrl:any="http://admin.savyajewelsbusiness.com/admin/";
    manufacturer: any;
    category: any;
    subcategory: any;
    Banner: any;
  result: any;
    constructor(private route:ActivatedRoute,private api:ApiService,
      private sanitizer: DomSanitizer,
      private router:Router) {
      this.route.params.subscribe(params => {
        this.subid = params.id;
        this.getsubsub();});
    
     }
  
     getsubsub() {
      this.api.Post(SUBCATEGORYTYPE, {subcategory_id: this.subid } ).then(data  => {
        this.page=true;
        this.loader=false;
        this.data = data['data'];
        console.log(data);
  
        this.api.Post(CATEGORY, {} ).then(data  => {
          let result = data['data'].find(x => x.id == this.data[0]['category_id']);
          this.category = result['category'];
          console.log(this.category);
       }).catch(d=>{console.log(d);});
  
       this.api.Post(SUBCATEGORY, {category_id: this.data[0]['category_id']} ).then(data  => {
        let result = data['data'].find(x => x.id == this.data[0]['subcategory_id']);
        this.result = data['data'].find(x => x.id == this.data[0]['subcategory_id']);
        this.subcategory = result['subcategory'];
        console.log(this.subcategory);
      }).catch(d=>{
          console.log(d);
        });
       }).catch(d=>{
        console.log(d);
      });
    }
    getlink(s):SafeStyle {
      s = s.replace(/ /g, "%20");
       s = s.replace(/\(/g, "%28");
       s = s.replace(/\)/g, "%29");
      return this.sanitizer.bypassSecurityTrustStyle('url('+ IMAGE + 'subsubcategory/' + s + ')');
    }
    gofilter(value) {
      console.log(value);
      this.router.navigate(['/filter', value],{queryParams:{'page':1}});
    }
  
    ngOnInit(): void {
      this.loader=true;
      this.page=false;
    }
  
  }
